import { useEffect, useState } from "react";
import "../../styles/modal.css";

export default function AdminEditModal({ open, admin, onClose, onSubmit }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    tel: "",
    password: "",
  });

  useEffect(() => {
    if (admin) {
      setForm({
        firstName: admin.firstName || "",
        lastName: admin.lastName || "",
        email: admin.contact?.email || "",
        username: admin.username || "",
        tel: admin.contact?.tel || "",
        password: "",
      });
    }
  }, [admin]);

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open || !admin) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const payload = { ...form };
    if (!payload.password) delete payload.password;

    onSubmit(admin.id, payload);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Modifier administrateur</h3>

        <form onSubmit={handleSubmit} className="modalForm">
          <div className="formGrid">
            <Input label="Prénom" name="firstName" required value={form.firstName} onChange={handleChange} />
            <Input label="Nom" name="lastName" value={form.lastName} onChange={handleChange} />
            <Input label="Email" name="email" type="email" required value={form.email} onChange={handleChange} />
            <Input label="Username" name="username" required value={form.username} onChange={handleChange} />
            <Input label="Téléphone" name="tel" required value={form.tel} onChange={handleChange} />
            <Input
              label="Mot de passe (optionnel)"
              name="password"
              type="password"
              placeholder="Laisser vide pour ne pas changer"
              value={form.password}
              onChange={handleChange}
            />
          </div>

          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button className="btnPrimary">
              Mettre à jour
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}
